<script>
// NOTICE: KAPTION-INTEGRATION
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import KaptionResponsePolicyForm from './KaptionResponsePolicyForm.vue';

export default {
  components: {
    SettingsLayout,
    BaseSettingsHeader,
    KaptionResponsePolicyForm,
  },
  computed: {
    ...mapGetters({
      uiFlags: 'kaptionResponsePolicies/getUIFlags',
    }),
  },
  methods: {
    async handleSubmit(data) {
      try {
        await this.$store.dispatch('kaptionResponsePolicies/create', data);
        useAlert(this.$t('KAPTION_RESPONSE_POLICIES.ADD.API.SUCCESS_MESSAGE'));
        this.$router.push({
          name: 'settings_kaption_response_policies',
        });
      } catch (error) {
        useAlert(this.$t('KAPTION_RESPONSE_POLICIES.ADD.API.ERROR_MESSAGE'));
      }
    },
    handleCancel() {
      this.$router.push({
        name: 'settings_kaption_response_policies',
      });
    },
  },
};
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader
        :title="$t('KAPTION_RESPONSE_POLICIES.ADD.TITLE')"
        :description="$t('KAPTION_RESPONSE_POLICIES.ADD.DESC')"
        :back-url="{
          name: 'settings_kaption_response_policies',
        }"
      />
    </template>
    <template #body>
      <div class="mx-auto max-w-lg">
        <KaptionResponsePolicyForm
          :is-submitting="uiFlags.creatingItem"
          :submit-label="$t('KAPTION_RESPONSE_POLICIES.FORM.SUBMIT')"
          @submit="handleSubmit"
          @cancel="handleCancel"
        />
      </div>
    </template>
  </SettingsLayout>
</template>
